export const IMAGE_QUALITY_LIST: { [key in 'FHD' | 'HD' | 'SD']: number } = {
  FHD: 1920,
  HD: 1024,
  SD: 800
};
